/** 变更台账（changelog.md）：只读 `GET /changes`。
 *
 * 变更记录的取数来源尚未裁决，后端如实 501「只读端点未接数据源」；这一屏整屏显示「接口未提供」与卡名，
 * 不渲染原型数据、不显示任何计数。接上数据源后按字段草案渲染（解析器 `parseChanges`）。
 */

import { notProvided, useChanges } from "../../api/g4";
import { Card, Lede, Note, PageHead } from "../../components/Card";
import { Pill } from "../../components/Pill";
import { Table } from "../../components/Table";
import { ScreenState } from "../p2/Common";
import { Missing } from "../g4/Section";

const KINDS = ["策略", "参数", "数据源", "依赖"];

export function ChangelogScreen(): React.ReactNode {
  const changes = useChanges();
  const gap = changes.status === "error" ? notProvided(changes.error) : null;
  return (
    <>
      <PageHead title="变更台账" sub="GET /changes · change-validation（planned）" />
      <Lede>每一次影响绩效的变更改了什么、谁改的、验收结论是什么。只做登记与查询；能不能合入由「变更验收」判定。</Lede>
      {gap ? (
        <Card title="接口未提供">
          <Note tone="warn">
            接口未提供：变更台账（<code>GET /changes</code>）尚未接线 · {gap.detail} · 对应卡 change-validation（planned）「变更台账」
          </Note>
        </Card>
      ) : (
        <ScreenState query={changes} what="变更台账">
          {(rows) => (
            <>
              <div className="grid g4">
                {KINDS.map((k) => (
                  <Card key={k} title={k}>{rows.filter((r) => r.kind === k).length}</Card>
                ))}
              </div>
              <Card title="变更列表" nopad>
                <Table
                  cols={[{ label: "时间" }, { label: "类别" }, { label: "对象" }, { label: "变更前" }, { label: "变更后" }, { label: "提交人" }, { label: "验收结论" }, { label: "环境差异", wrap: true }]}
                  rows={rows.map((r) => ({
                    key: r.change_id,
                    cells: [
                      r.ts_utc,
                      r.kind,
                      r.subject,
                      r.before ?? "—",
                      r.after ?? "—",
                      r.operator,
                      r.review.verdict === "待验收" ? (
                        <Pill tone="warn">待验收</Pill>
                      ) : r.review.review_id === null ? (
                        <Pill tone="bad">结论缺验收记录</Pill>
                      ) : (
                        <a href={`#changereview?id=${encodeURIComponent(r.review.review_id)}`}>{r.review.verdict}</a>
                      ),
                      r.env_note === null ? <Pill tone="bad">未标注</Pill> : r.env_note === "" ? "无差异" : r.env_note,
                    ],
                  }))}
                  empty="还没有登记任何变更"
                />
              </Card>
              {rows.some((r) => r.review.summary === null) ? <Note>部分行验收摘要 <Missing /></Note> : null}
            </>
          )}
        </ScreenState>
      )}
    </>
  );
}
